<template>

    <div style="display: flex; justify-content: space-between; padding-right: 30px;">
      <span class="sub-title-dashboard">Resumen</span>
      <span >{{ getDateFormat(dates.start) }} a {{ getDateFormat(dates.end) }}</span>
    </div>

    <div class="row-cards-info-dashboard">

        <div class="card-info-dashboard">
            <span class="title-card">Puntos de Venta</span>
            <span class="info-card">{{ responseData.length }}</span>
        </div>

        <div class="card-info-dashboard">
            <span class="title-card">Ventas Totales</span>
            <span class="info-card">{{ intToMoney(totalSales)}}</span>
        </div>

        <div class="card-info-dashboard">
            <span class="title-card">Ticket Promedio</span>
            <span class="info-card">{{ intToMoney(totalAverage) }}</span>
        </div>

        <div class="card-info-dashboard">
            <span class="title-card">Órdenes</span>
            <span class="info-card">{{ totalOrders - cancelOrders }}</span>
        </div>

    </div>

    <span class="sub-title-dashboard">Operaciones por Punto de Venta</span>

    <div class="chart-card" v-for="item  in responseData" :key="item._id"
    style="margin-top: 20px; margin-inline: 30px;">
      <span class="title-card">{{ item.name }}</span>
      <span class="info-card">{{ intToMoney (getTotalPos(item.terminals)) }}</span>
      <BarChartGrup
        :labels="item.terminals.map(t => t.createdBy)"
        :efectivo="item.terminals.map(t => t.cash)"
        :debito="item.terminals.map(t => t.debit)"
        :credito="item.terminals.map(t => t.credit)"
        :deposit="item.terminals.map(t => t.deposit)"
        :transfer="item.terminals.map(t => t.transfer)"
        />
    </div>
    <div class="grid-chart-50">

        <div class="chart-card">
            <span class="title-card">Nivel de Eficiencia</span>
             <BarHorizontalChart
              :labels="responseData.map(r => r.name)"
              :success="responseData.map(r => r.deliveredOk)"
              :canceled="responseData.map(r => r.orders - r.deliveredOk - r.canceled)"
              :sections ="['Entregas en tiempo','Entregas fuera de tiempo']"
            />
        </div>

        <div class="chart-card">
            <span class="title-card">Distribución por Ventas</span>
            <DonutChart
                :labels="responseData.map(r => r.name)"
                :data="responseData.map(r => {
                    // aquí decides qué valor mostrar, por ejemplo el total de ventas en efectivo
                    return r.terminals.reduce((sum, t) => sum + t.cash + t.deposit + t.debit + t.credit + t.transfer, 0)
                })"
                :colors="['#222222', '#FB925A', '#FF5700', '#FFB84C', '#FF7043']"
            />
        </div>

        <div class="chart-card">
            <span class="title-card">Tasa de Órdenes Correctas vs Canceladas</span>
             <BarHorizontalChart
                :labels="responseData.map(r => r.name)"
                :success="responseData.map(r => r.orders - r.canceled)"
                :canceled="responseData.map(r => r.canceled)"
                :sections ="['Correctas','Canceladas']"
            />
        </div>
        <div class="chart-card">
            <span class="title-card">Productos Vendidos</span>
            <table class="table-products">
                <thead>
                <tr>
                    <th style="width: 60%;">Producto</th>
                    <th style="width: 10%;">Unidades</th>
                    <th @click="toggleSort" style="cursor:pointer; width: 30%;">
                        Ingresos
                        <v-icon small class="ml-1">
                            {{ sortDes ? 'mdi-arrow-up' : 'mdi-arrow-down' }}
                        </v-icon>
                    </th>
                </tr>
                </thead>
            </table>
            <div class="table-wrapper" >
                <div class="table-body" >
                    <table class="table-products" >
                    <tbody>
                        <tr v-for="product in sortedProducts" :key="product._id">
                            <td style="width: 60%;">{{ product.name }}</td>
                            <td style="width: 10%;">{{ product.quantity }}</td>
                            <td style="width: 30%;">${{ product.price * product.quantity }}</td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <span class="sub-title-dashboard">Patrones de Venta</span>

    <div class="chart-card-100">
        <span class="title-card">Ventas Totales {{ yearNow }}</span>
        <BarChartGrup
        :labels="['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']"
        :efectivo="responseYear.currentYearPayments.cash"
        :debito="responseYear.currentYearPayments.debit"
        :credito="responseYear.currentYearPayments.credit"
        :deposit="responseYear.currentYearPayments.deposit"
        :transfer="responseYear.currentYearPayments.transfer"
        />
    </div>

    <div class="chart-card-100">
        <span class="title-card">Comparativo de Ventas Anual</span>
        <LineChart
        :labels="['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']"
        :periodoActual="responseYear.currentYear"
        :periodoAnterior="responseYear.lastYear"

        />
    </div>

    <div class="grid-chart-50">

        <div class="chart-card" style="max-width: 100%;">
            <span class="title-card">Ventas por Horario</span>
            <BarAverageChart
                :labels="['8 AM','9AM','10 AM','11 AM','12 PM','1 PM','2 PM','3 PM', '4 PM', '5 PM', '6 PM', '7 PM', '8 PM', '9 PM', '10 PM', '11 PM']"
                :data="responseDay.byHour"
            />
        </div>

        <div class="chart-card" style="max-width: 100%;">
            <span class="title-card">Ventas por Día de la Semana</span>
            <BarAverageChart
                :labels="['Lunes','Martes','Miercoles','Jueves','Viernes','Sabado','Domingo']"
                :data="responseDay.byWeek"
            />
        </div>
    </div>

</template>
<script>
import BarChartGrup from '@/components/chart/BarChartGrup.vue'
import LineChart from '@/components/chart/LineChart.vue'
import DonutChart from '@/components/chart/DonutChart.vue'
import BarHorizontalChart from '@/components/chart/BarHorizontalChart.vue'
import BarAverageChart from '@/components/chart/BarAverageChart.vue'
import dashboardApi from '@/api/dashboardApi'
import moneyTransform from '@/utils/moneyTransform'
import dateTransform from '@/utils/dateTransform'
export default {
  name: 'CommerciaVueDashboard',
  components: {
    BarChartGrup,
    LineChart,
    DonutChart,
    BarHorizontalChart,
    BarAverageChart
  },
  props: {
    busines: { type: String, required: true },
    dates: { type: Object, required: true },
    terminal: { type: String, required: true }
  },
  data () {
    return {
      responseData: [],
      totalSales: 0,
      totalAverage: 0,
      totalOrders: 0,
      cancelOrders: 0,
      yearNow: new Date().getFullYear(),
      sortDes: true,
      responseDay: { byWeek: [], byHour: [] },
      responseYear: {
        currentYear: [],
        lastYear: [],
        currentYearPayments: {
          cash: [],
          debit: [],
          credit: [],
          transfer: [],
          deposit: []
        }
      }
    }
  },
  computed: {
    mergedProducts () {
      return this.responseData.flatMap(item => item.products)
    },
    sortedProducts () {
      return [...this.mergedProducts].sort((a, b) => {
        const totalA = a.price * a.quantity
        const totalB = b.price * b.quantity
        return this.sortDes ? totalB - totalA : totalA - totalB
      })
    }
  },
  watch: {
    dates: {
      deep: true,
      immediate: true,
      handler (_, v) {
        this.getData()
      }
    },
    terminal: {
      handler (_, v) {
        this.getData()
      }
    }
  },
  methods: {
    getDateFormat (date) { return dateTransform.formatTable(date) },
    intToMoney (val) { return moneyTransform.intToMoney(val) },
    toggleSort () {
      this.sortDes = !this.sortDes
    },
    async getData () {
      const startDate = new Date(this.dates.start)
      const endDate = new Date(this.dates.end)

      startDate.setHours(0, 0, 0, 0)
      endDate.setHours(23, 59, 59, 999)

      this.responseData = await dashboardApi.adminAll(
        this.busines,
        startDate.getTime(),
        endDate.getTime(),
        this.terminal
      )
      this.getTotals()
      this.responseDay = await dashboardApi.adminDay(
        this.busines,
        startDate.getTime(),
        endDate.getTime(),
        this.terminal
      )
      this.responseYear = await dashboardApi.adminYear(
        this.busines,
        this.terminal
      )
    },
    getTotals () {
      this.totalOrders = 0
      this.cancelOrders = 0
      let weightedAverage = 0
      let sumTotalSales = 0
      for (const pos of this.responseData) {
        this.totalOrders += pos.orders
        if (pos.canceled) this.cancelOrders += pos.canceled
        weightedAverage += pos.average * pos.orders
        for (const cashier of pos.terminals) {
          sumTotalSales += cashier.deposit
          sumTotalSales += cashier.cash
          sumTotalSales += cashier.debit
          sumTotalSales += cashier.credit
          sumTotalSales += cashier.transfer
        }
      }
      this.totalSales = sumTotalSales
      this.totalAverage = this.totalOrders > 0
        ? Math.ceil(weightedAverage / (this.totalOrders - this.cancelOrders))
        : 0
    },
    getTotalPos (terminals) {
      console.log('terminals.length')
      console.log(terminals.length)
      let total = 0
      for (const termianl of terminals) {
        total += termianl.deposit
        total += termianl.cash
        total += termianl.debit
        total += termianl.credit
        total += termianl.transfer
      }
      return total
    }
  }
}
</script>

<style scoped>
  @import '@/assets/styles/sections.css';
  @import '@/assets/styles/inputs.css';
  @import '@/assets/styles/dashboard.css';
</style>
